import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { selectSeason, selectLeagues, selectTeams } from '../../../../core/duck';
import { fetchScoutReport, getScoutReport, getScoutReportHeader,
  reorderGrid, addPlayer, removePlayer, changeConfig,
  changePlayerContent, changePlayerConfiguration, changeContent,
  fetchTeamJerseyNumbers } from '../../duck';
import ReportHeader from '../../components/ReportHeader';
import PlayersGrid from '../../components/PlayersGrid';
import AddPlayerSelect from '../../components/AddPlayerSelect';
import ReportConfig from '../../components/ReportConfig';
import Spinner from '../../../../components/Spinner';
import Box from '../../../../components/Box';
import TextEditor from '../../../../components/TextEditor';
import LastResults from '../../components/LastResults';
import LastGamesAverageStats from '../../components/LastGamesAverageStats';
import AccumulatedStats from '../../components/AccumulatedStats';
import StatsBreakdown from '../../components/StatsBreakdown';
import StartersVsBench from '../../components/StartersVsBench';
import BestWorst from '../../components/BestWorst';
import PlayersList from '../../components/PlayersList';
import { sortBy, toArray, pick } from 'lodash';
import './ScoutReport.css';

class ScoutReport extends React.Component {
  // TODO: this should be on team level
  setUserContext = (seasonId, leagueId, teamId) => {
    const { dispatch } = this.props;

    dispatch(selectSeason(seasonId));
    dispatch(selectLeagues([leagueId]));
    dispatch(selectTeams([teamId]));
  }

  componentDidMount() {
    const {
      params: {
        seasonId, leagueId, teamId
      }, dispatch
    } = this.props;

    this.setUserContext(seasonId, leagueId, teamId);
    dispatch(fetchScoutReport(seasonId, leagueId, teamId));
    dispatch(fetchTeamJerseyNumbers(seasonId, leagueId, teamId));
  }

  onGridReorder = (grid) => {
    const { dispatch, scoutReport: { id } } = this.props;
    dispatch(reorderGrid(id, grid, dispatch));
  };

  onRemovePlayer = (playerId) => {
    const { dispatch, scoutReport: { id } } = this.props;
    dispatch(removePlayer(id, playerId, dispatch));
  };

  onAddPlayer = (_, playerData) => {
    const { dispatch, scoutReport: { id, playersGrid } } = this.props;

    // check that the selected player is not already in the report
    for (let i = 1; i <= 5; i++) {
      if (playersGrid[i].map(id => parseInt(id, 10)).indexOf(playerData.id) > -1) {
        return;
      }
    }

    dispatch(addPlayer(id, playerData, dispatch));
  };

  defaultConfig = {
    combinedStats: false,
    lastResults: 5,
    showAccumulatedStats: true,
    showTeamRank: true,
    showStatsBreakdown: true,
    showStartersBench: true,
    bestWorst: 5,
    playersOrderBy: "grid",
    showPlayersStatsAllGames: true,
    showPlayersStatsWonGames: true,
    showPlayersStatsLostGames: true,
    showPlayersStatsHomeGames: true,
    showPlayersStatsAwayGames: true,
    showPlayersStatsTotal: true,
    breakPageAfterTeamStats: false,
    breakPageAfterTeamCharacteristics: false
  }

  onConfigChange = (key, value) => {
    const { dispatch, scoutReport: { id, reportConfiguration } } = this.props;
    dispatch(changeConfig(id, key, value, {
      ...(reportConfiguration || {}),
      [key]: value
    }, dispatch));
  }

  onContentChange = (key, dbColumn, content) => {
    const { dispatch, scoutReport: { id } } = this.props;
    dispatch(changeContent(id, key, dbColumn, content, dispatch));
  };

  onPlayerContentChange = (playerId, content) => {
    const { dispatch, scoutReport: { id } } = this.props;
    dispatch(changePlayerContent(id, playerId, content, dispatch));
  };

  onPlayerConfigurationChange = (playerId, config) => {
    const { dispatch, scoutReport: { id } } = this.props;
    dispatch(changePlayerConfiguration(id, playerId, config, dispatch));
  };

  getOrderedPlayersIds = () => {
    const {
      scoutReport: {
        reportConfiguration,
        playersGrid,
        playersData
      },
      route: { editMode }
    } = this.props;

    // in edit mode, always sort by player name
    if (editMode) {
      return sortBy(toArray(playersData), p => p.position ? `${p.position.id}-${p.id}` : `9-${p.id}`).map(p => p.id);
    }

    const { playersOrderBy } = reportConfiguration || {};

    let ids = [];
    switch (playersOrderBy) {
      case "jersey":
        return sortBy(toArray(playersData), p => p.jerseyNumber >= 0 ? p.jerseyNumber : 999).map(p => p.id);
      case "position":
        // sort by grid columns
        for (let i = 1; i <= 5; i++) {
          if (playersGrid[i] && playersGrid[i].length) {
            playersGrid[i].map(id => ids.push(id));
          }
        }
        return ids;
      case "grid":
      default:
        // sort by grid rows
        for (let i = 0; i < Math.max(
          playersGrid["1"].length,
          playersGrid["2"].length,
          playersGrid["3"].length,
          playersGrid["4"].length,
          playersGrid["5"].length
        ); i++) {
          if (playersGrid["1"][i]) ids.push(playersGrid["1"][i]);
          if (playersGrid["2"][i]) ids.push(playersGrid["2"][i]);
          if (playersGrid["3"][i]) ids.push(playersGrid["3"][i]);
          if (playersGrid["4"][i]) ids.push(playersGrid["4"][i]);
          if (playersGrid["5"][i]) ids.push(playersGrid["5"][i]);
        }
        return ids;
    }
  };

  render() {
    const {
      scoutReport,
      scoutReportHeader,
      params: { seasonId, leagueId, teamId },
      route: { editMode }
    } = this.props;

    const reportConfig = {
      ...this.defaultConfig,
      ...(scoutReport.reportConfiguration || {})
    }

    return (
      <div>
        { scoutReport.isFetching &&
          <Spinner />
        }
        { scoutReport.id &&
          <div>
            { editMode &&
              <Link to={ `${this.props.location.pathname}/view` }>
                <button type="button"
                        className="btn btn-primary hidden-print btn-mode">
                  <span className="glyphicon glyphicon glyphicon-ok" aria-hidden="true"></span> Generate Report
                </button>
              </Link>
            }
            { !editMode &&
              <ReportHeader data={ scoutReportHeader } teamId={ teamId } />
            }
            { !editMode &&
              <span className="hidden-print">
                <Link to={ this.props.location.pathname.replace('/view', '') }>
                  <button type="button"
                          className="btn btn-primary btn-mode">
                    <span className="glyphicon glyphicon glyphicon-cog" aria-hidden="true"></span> Back to Setup
                  </button>
                </Link>
                <button type="button"
                        className="btn btn-primary btn-mode btn-mode-print"
                        onClick={ window.print }>
                  <span className="glyphicon glyphicon glyphicon-print" aria-hidden="true"></span> Print Report
                </button>
              </span>
            }
            <PlayersGrid grid={ scoutReport.playersGrid }
                         playersData={ scoutReport.playersData }
                         onChange={ this.onGridReorder }
                         onRemovePlayer={ this.onRemovePlayer }
                         enableSorting={ editMode } />
            { editMode &&
              <AddPlayerSelect onSelect={ this.onAddPlayer } />
            }
            { editMode &&
              <ReportConfig config={ reportConfig }
                            onChange={ this.onConfigChange } />
            }
            { !editMode && reportConfig.lastResults &&
              <LastResults url={ `v1/stats/team/team_stats/?season=${seasonId}&league=${leagueId}&team=${teamId}&last=${reportConfig.lastResults}&combined=${reportConfig.combinedStats}` }
                           last={ reportConfig.lastResults }
                           combined={ reportConfig.combinedStats }
                           team={ teamId } />
            }
            { !editMode && reportConfig.lastResults &&
              <LastGamesAverageStats url={ `v1/stats/team/average_stats/?season=${seasonId}&league=${leagueId}&team=${teamId}&last=${reportConfig.lastResults}&combined=${reportConfig.combinedStats}` }
                                     last={ reportConfig.lastResults }
                                     combined={ reportConfig.combinedStats } />
            }
            { !editMode && reportConfig.showAccumulatedStats &&
              <AccumulatedStats url={ `v1/stats/team/average_stats_home_away_won_lost/?season=${seasonId}&league=${leagueId}&team=${teamId}&combined=${reportConfig.combinedStats}` }
                                combined={ reportConfig.combinedStats }
                                showTeamRank={ reportConfig.showTeamRank }
                                season={ seasonId }
                                league={ leagueId }
                                team={ teamId }
                                shouldComponentUpdate={ function(nextProps) {
                                  return (this.props.showTeamRank !== nextProps.showTeamRank)
                                }} />
            }
            { !editMode && reportConfig.showStatsBreakdown &&
              <StatsBreakdown url={ `v1/stats/team/average_stats/?season=${seasonId}&league=${leagueId}&team=${teamId}&combined=${reportConfig.combinedStats}` }
                              combined={ reportConfig.combinedStats }
                              last={ reportConfig.lastResults } />
            }
            { !editMode && reportConfig.showStartersBench &&
              <StartersVsBench url={ `v1/stats/team/players_average_stats_starters_vs_bench/?season=${seasonId}&league=${leagueId}&team=${teamId}&combined=${reportConfig.combinedStats}` }
                               combined={ reportConfig.combinedStats } />
            }
            { !editMode && reportConfig.bestWorst &&
              <BestWorst url={ `v1/stats/team/players_average_stats/?season=${seasonId}&league=${leagueId}&team=${teamId}&last=${reportConfig.bestWorst}&combined=${reportConfig.combinedStats}` }
                         last={ reportConfig.bestWorst }
                         combined={ reportConfig.combinedStats } />
            }
            { !editMode && reportConfig.breakPageAfterTeamStats &&
              <div className="page-break-before" />
            }
            { (
                editMode
                || (!editMode && scoutReport.teamCharacteristics !== "")
              ) &&
              <Box title={ "Team Characteristics" }
                   className={ `${reportConfig.breakPageAfterTeamCharacteristics ? 'page-break-after' : ''}` }>
                <TextEditor id={ `team_characteristics` }
                            content={ scoutReport.teamCharacteristics }
                            printMode={ !editMode }
                            onChange={ (content) => this.onContentChange('teamCharacteristics', 'team_characteristics', content) } />
                { editMode &&
                  <div className="form-group hidden-print" style={{ marginTop: '-10px', marginBottom: 0 }}>
                    <div className="checkbox" style={{ marginBottom: '0'}}>
                      <label>
                        <input type="checkbox"
                               defaultChecked={ reportConfig.breakPageAfterTeamStats }
                               onChange={ (e) => this.onConfigChange('breakPageAfterTeamStats', e.target.checked) } />
                        <small>Break page before team characteristics (after stats) when printing</small>
                      </label>
                    </div>
                    <div className="checkbox" style={{ marginBottom: '0'}}>
                      <label>
                        <input type="checkbox"
                               defaultChecked={ reportConfig.breakPageAfterTeamCharacteristics }
                               onChange={ (e) => this.onConfigChange('breakPageAfterTeamCharacteristics', e.target.checked) } />
                        <small>Break page after team characteristics when printing</small>
                      </label>
                    </div>
                  </div>
                }
              </Box>
            }
            <PlayersList orderedPlayersIds={ this.getOrderedPlayersIds() }
                         playersData={ scoutReport.playersData }
                         { ...pick(reportConfig, [
                           'combinedStats',
                           'showPlayersStatsAllGames',
                           'showPlayersStatsWonGames',
                           'showPlayersStatsLostGames',
                           'showPlayersStatsHomeGames',
                           'showPlayersStatsAwayGames',
                           'showPlayersStatsTotal'
                         ]) }
                         season={ seasonId }
                         league={ leagueId }
                         team={ teamId }
                         editMode={ editMode }
                         onPlayerContentChange={ this.onPlayerContentChange }
                         onPlayerConfigurationChange={ this.onPlayerConfigurationChange } />

           { (
               editMode
               || (!editMode && scoutReport.keysToWin !== "")
             ) &&
             <Box title={ "Keys to Win" }>
               <TextEditor id={ `keys_to_win` }
                           content={ scoutReport.keysToWin }
                           printMode={ !editMode }
                           onChange={ (content) => this.onContentChange('keysToWin', 'keys_to_win', content) } />
             </Box>
           }
          </div>
        }
      </div>
    );
  }
}

export default connect(
  state => ({
    scoutReport: getScoutReport(state),
    scoutReportHeader: getScoutReportHeader(state)
  })
)(ScoutReport);



// WEBPACK FOOTER //
// ./src/features/scout-report/containers/ScoutReport/ScoutReport.js